export default "__VITE_ASSET__BENU1BTB__"